import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Component from './Component';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, data, error, message, selectedCourier,
  } = state.courier;
  return {
    isLoading,
    data,
    error,
    message,
    selectedCourier,
  };
}

const Styled = withStyles(styles)(Component);

export default connect(
  mapStateToProps,
)(Styled);
